import React from 'react'

import { AlignItems, Box, Display } from '@gousto-internal/citrus-react'

import type { RecipeTagGroups } from '@library/api-menu-experience'

import { TagPill } from './TagPill'

type RecipeQuickStatsProps = {
  tagGroups?: RecipeTagGroups
}

export const RecipeQuickStats = ({ tagGroups }: RecipeQuickStatsProps) => {
  if (!tagGroups?.key?.length) {
    return null
  }

  return (
    <Box
      alignItems={AlignItems.FlexStart}
      wrap
      data-testid="RecipeQuickStats"
      display={Display.Flex}
    >
      {tagGroups?.key?.map((tag) => (
        <TagPill key={tag.type} type={tag.type} text={tag.text} />
      ))}
    </Box>
  )
}
